module.exports = __webpack_public_path__ + "static/media/otherupd.aec575f2.svg";